import { Component } from 'js-component-framework';
import Headroom from 'headroom.js';

/*
 * Component for elements that have headroom applied.
 *
 * Expected config:
 *
 *  querySelector: {
 *    controller: '',
 *    target: '',
 *  },
 *  options: {
 *    headroom,
 *    ariapopup: {},
 *  }
 */
export default class ScrollEffect extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    // Initiate the component
    super(config);

    // Do nothing if function has already run.
    if (document.body.classList.contains('scrollEffect-applied')) {
      return;
    }

    // Add flag to so we don't run this function again
    document.body.classList.add('scrollEffect-applied');

    // Instantiate libraries
    this.initHeadroom();
  }

  /**
   * Applies the Headroom module to this.element
   */
  initHeadroom() {
    // Instantiate headroom
    const { element, options: { headroom: options } } = this;
    const headroomElement = new Headroom(element, options);
    headroomElement.init();
  }
}
